<template>
    <div class="Card fadeInBottomLeft wow">
        <div class="left-box">
            <span>{{item.title}}</span>
            <section>
                {{item.content}}
            </section>
        </div>
        <div class="right-box">
            <img :src="require(`../../assets/images/Home/${item.bg}`)" alt="">
        </div>
    </div>
</template>

<script>
import img from '../../assets/images/Home/1-pd.png'
export default {
    data(){
        return {
            
        }
    },
    props:['item'],
    mounted(){

    }
}
</script>

<style lang="scss" scoped>
    .Card{
        margin-top: 54px;
        justify-content: space-between;
        display: flex;
        flex-direction: row;
        height: 240px;
        .left-box{
            text-align: left;
            margin-right: 40px;
            border-bottom: 1px solid #DEDEDE;
            >span{
                font-size: 22px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #333333;
                line-height: 30px;
            }
            section{
                max-width: 908px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                line-height: 36px;    
            }
        }
        .right-box{
            img{
                width:375px;
                height: 240px;
                display: inline-block;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/componentsNew/common/Card.vue